<template>
  <div>
    <!-- <van-nav-bar :title="$route.meta.title" :fixed="true" /> -->
    <div class="branch-main" v-if="active === '1'">
      <div class="banner">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="item in bannerList" :key="item.id">
            <img :src="item.mainPicUrls" alt="" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="select-text">{{ $t("insOutsText") }}</div>
      <div v-if="branchList.length > 0">
        <div
          class="branch-item"
          v-for="item in branchList"
          :key="item.branchId"
          @click="handleSelectMenu(item)"
        >
          <div class="icon">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAABYUlEQVRIS+2UIUhEQRCGv78ZDAqCxWBQMBi0WQRtBsFyTW1WUbFctInNIgYFDTaviIIXBC8aDCcWw4En2rxouCCMzGP3eIgvHG+jf9i37Lz9dpj5d0WQma0Ah8B4XOvz2wa2JV35PvlgZoPAOzDUJ+z379/ApKR2BK8CFyWhcXtV0kEEXwKVROCGpEWZ2QDwCXg5UsjLMezgZeA6BTHHqDj4BNhIDD538GsJixXl03awJc42wznYGzeSGN5x8C2wlBhcd/ACcF8AbgAe/0tFMbfbfLwgnvFxrokdYE/SkZmtAfvAWKB/ADuSama2C1RzpfT3YlPSTQaOMjN/gPzCtMLaFlCT9GZmE1lTpJaZjfrBwCnwBHis629EZMWMvc5d4A74AqbCFc82AHWgGebTIeYJuB6AlzCfCYfPRnBSy8nlJ6T28j+45658KZ4B73YKNSX1XDEHnAWblYG77dYlPf4AjNyMtTjFsy0AAAAASUVORK5CYII="
              alt=""
            />
          </div>
          <div class="text">
            {{
              language == "CN"
                ? item.branchName
                : item.branchNameEn || item.branchName
            }}
          </div>
          <img
            class="r-icon"
            src="data:image/png;base64,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"
            alt=""
          />
        </div>
      </div>
      <div v-else class="notShop">{{ $t("noneBranch") }}</div>
    </div>
    <div v-if="active === '2'">
      <OrderList ref="orderCom" orderType="39" />
    </div>
    <van-tabbar v-model="active">
      <van-tabbar-item icon="shop-o" name="1">{{
        $t("workshopTabbar1")
      }}</van-tabbar-item>
      <van-tabbar-item icon="label-o" name="2">{{
        $t("workshopTabbar2")
      }}</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import OrderList from "../order/List.vue";
export default {
  props: {
    type: String,
    filterBranch: Function,
    branchType: String,
  },
  components: {
    OrderList,
  },
  data() {
    return {
      bannerList: [],
      shopId: "",
      branchList: [],
      disabledBranch: [],
      active: "1",
      language: "",
    };
  },
  watch: {
    active(e) {
      if(e == 2) {
        window.document.title = this.$t('plantOrderTitle')
      } else {
        const title = this.$router?.history?.current?.meta?.title;
        window.document.title = this.$t(title)
      }
    }
  },
  async activated() {
    // console.log('1')
    this.init();
  },
  async created() {
    // console.log('2');
    // this.init();
  },
  mounted() {},
  methods: {
    async init() {
      console.log(this.$route.params, "param");
      if (this.$route.params.isList) {
        const canGetList = this.active == "1";
        this.active = "2";
        this.$nextTick(() => {
          this.$refs["orderCom"].reload(!canGetList);
        });
      }
      this.shopId = localStorage.getItem("shopId");
      this.language = localStorage.getItem("language");
      if (this.branchType === "privateroom") {
        this.getCustomerBranchList();
        return;
      }

      await this.getBranchConfig();
      setTimeout(() => {
        this.getBranchList();
        this.getBranchBannerList();
      }, 100);
    },
    // 获取banner
    async getBranchBannerList() {
      const { data: res } = await this.$authAjax.get(
        "/api/shopBannerInfo/listForH5",
        {
          params: {
            shopId: this.shopId,
            linkType: 2,
          },
        }
      );
      console.log(res, "===branch banner");
      this.bannerList = res.data?.list;
    },
    // 获取分店配置
    async getBranchConfig() {
      let data = {
        shopId: this.shopId,
        paramName: "Reserve_Order_Forbidden_Display_BranchId",
      };
      return this.$authAjax
        .post("/api/shop/getShopConfig", data)
        .then((res) => {
          let { data } = res;
          if (data.code == 200) {
            if (data.data.configList[0]) {
              this.disabledBranch = data.data.configList[0].paramValue.split(
                ","
              );
            }
          }
        });
    },
    async getCustomerBranchList() {
      // /customer/branch/list
      let req = {
        shopId: this.shopId,
        customerId: this.customerId,
      };
      const { data: resData } = await this.$authAjax.post(
        "/api/privateroom/customer/branch/list",
        req
      );
      const data = resData.data;
      this.branchList = data;

      if (data.length == 1) {
        sessionStorage.setItem("branchId", data[0].branchId);
        sessionStorage.setItem("branchName", data[0].branchName);

        if (this.type === "component") {
          this.$emit("selected", {
            ...data[0],
          });
        } else {
          this.$router.replace({
            path: "/card/package",
          });
        }
      }
    },
    getBranchList() {
      const locationId = localStorage.getItem("locationId");
      const roles = JSON.parse(localStorage.getItem("customerInfoList"));
      const customerId =
        (roles && roles[0] && roles[0].customerId) ||
        localStorage.getItem("customerId");
      const loading = this.$toast.loading({
        message: this.language == "CN" ? "加载中..." : "Loading...",
        forbidClick: true,
        loadingType: "spinner",
        // duration: 0
      });
      let data = {
        shopId: this.shopId,
        levelNo: locationId || "",
        customerId: customerId || "",
        orderType: this.$route.query.type,
      };
      this.$authAjax
        .post("/api/wxapp/reserveMenu/branch/List", data)
        .then((res) => {
          console.log("res.data", res.data);
          let { data } = res.data;
          if (data.length == 1) {
            sessionStorage.setItem("branchId", data[0].branchId);
            sessionStorage.setItem(
              "branchName",
              this.language == "CN"
                ? data[0].branchName
                : data[0].branchNameEn || data[0].branchName
            );
          }
          this.branchList = data;
          loading.clear();
        });
    },
    handleSelectMenu(item) {
      // console.log(item);
      sessionStorage.setItem("branchId", item.branchId);
      sessionStorage.setItem(
        "branchName",
        this.language == "CN"
          ? item.branchName
          : item.branchNameEn || item.branchName
      );

      if (this.type === "component") {
        this.$emit("selected", {
          ...item,
        });
      } else {
        // this.$router.push({
        //   path: "/card/package",
        //   query: {
        //     branchId: item.branchId,
        //     branchName: item.branchName,
        //   },
        // });
        this.$router.push({
          path: "/card/packageForm",
          query: {
            branchId: item.branchId,
            branchName: item.branchName,
            type: this.$route.query.type,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.branch-main {
  padding: 18px;
  width: 100%;
  height: calc(100vh - 45px);
  background: #f2f2f2;
  // margin-top: 45px;
  box-sizing: border-box;
  overflow: auto;
  .banner {
    height: 150px;
    width: 336px;
    border-radius: 8px;
    margin-bottom: 18px;
    overflow: hidden;
    img {
      height: 150px;
      width: 342px;
    }
  }
  .select-text {
    font-size: 16px;
    margin-bottom: 21px;
  }
  .branch-item {
    display: flex;
    align-items: center;
    padding: 18px 12px;
    border-radius: 6px;
    background-color: #fff;
    margin-bottom: 12px;
    position: relative;
    overflow: hidden;
    box-shadow: 0px 2px 6px rgba(174, 214, 253, 0.4);
    .icon {
      width: 34px;
      height: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #2ab1e7;
      border-radius: 4px;
    }
    .r-icon {
      position: absolute;
      right: -4px;
      bottom: -2.5px;
      width: 44px;
      height: 44px;
    }
    .text {
      margin-left: 18px;
      font-size: 20px;
    }
    img {
      width: 17px;
      height: 17px;
    }
  }
  .notShop {
    color: red;
    text-align: center;
    font-size: 18px;
    margin-top: 50px;
  }
}
</style>
